import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import type { BreadcrumbComponentType } from "use-react-router-breadcrumbs";

import { NAMESPACES } from "@/constants/i18next.constants";

type TBreadcrumbLinkProps = BreadcrumbComponentType & {
  title: string;
  to: string;
};

function BreadcrumbLink({ title, to }: TBreadcrumbLinkProps) {
  const { t } = useTranslation(NAMESPACES.LAYOUT);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Link to={to}>{t(`header.${title}` as any)}</Link>;
}

export default BreadcrumbLink;
